import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';

const titleStyles = {
  color: '#000000',
  fontSize: '1.25rem',
  fontWeight: 'bold',
  textAlign: 'start',
};

const useStyles = makeStyles((theme) => ({
  danger: {
    color: 'black',
    fontWeight: '500',
  },
}));

export function ModalConfirm({
  title = 'Confirmar',
  message = 'Tem certeza que deseja continuar?',
  isOpen,
  cancel,
  confirm,
  cancelText = 'Cancelar',
  confirmText = 'Confirmar',
  isLoading = false,
}) {
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={isOpen}
      onClose={cancel}
      aria-labelledby="confirm-delete-dialog-title"
    >
      <DialogTitle id="confirm-delete-dialog-title">
        <Typography style={titleStyles} component="h1" variant="subtitle1">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <p className={classes.danger}>{message}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel} disabled={isLoading}>
          {cancelText}
        </Button>
        <Button onClick={confirm} color="primary" disabled={isLoading}>
          {isLoading ? 'Excluindo...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
